<template>
  <text-field-like
      :value="viewValue"
      :label="label"
      :placeholder="placeholder"
      :flat="flat"
      :hide-details="hideDetails"
      :loading="loading"
      :color="color">
  </text-field-like>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {mapActions} from "vuex";
export default {
  name: "OwnerField",
  components: {TextFieldLike},
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
    },
    valueHandler: {
      type: Function,
      default: owner => owner
    }
  },
  data() {
    return {
      owner: null,
      viewValue: null,
      loading: true
    }
  },
  methods: {
    ...mapActions({
      getOwner: 'hcs/owner/get'
    }),
    updateViewValue() {
      if(this.owner === null) {
        this.viewValue = '';
        return;
      }
      const owner = this.valueHandler(this.owner);
      if(typeof owner === 'string' || owner instanceof String) {
        this.viewValue = owner;
      } else {
        this.viewValue = owner?.name ?? '';
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      async handler(ownerId) {
        if(ownerId) {
          this.loading = true;
          this.owner = await this.getOwner(ownerId);
        } else {
          this.owner = null;
        }
        this.loading = false;
        this.updateViewValue();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
